import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("p", null, " We use cookies to store user settings and collect usage statistics via Google Analytics (GA). Tracking usage helps us convince funding agencies to provide the essential grants our work relies on. ", -1);
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("p", null, " We'll never use GA to record your molecular structures or analyses. GA only gathers basic user data like tracking IDs, IP addresses, and device details. This data is sent to Google in the U.S. for processing and so is subject to U.S. law. ", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_PluginPathLink = _resolveComponent("PluginPathLink");
    const _component_PluginComponent = _resolveComponent("PluginComponent");
    return (_openBlock(), _createBlock(_component_PluginComponent, {
        infoPayload: _ctx.infoPayload,
        modelValue: _ctx.open,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.open) = $event)),
        onOnPopupDone: _ctx.onPopupDone,
        onOnPopupCancel: _ctx.onPopupCancel,
        onOnUserArgChanged: _ctx.onUserArgChanged,
        actionBtnTxt: "Accept",
        cancelBtnTxt: "Decline"
    }, {
        default: _withCtx(() => [
            _createElementVNode("div", null, [
                _hoisted_1,
                _hoisted_2,
                _createElementVNode("p", null, [
                    _createTextVNode(_toDisplayString(_ctx.appName) + " is accessible without cookies enabled. If you enable cookies, you can disable them anytime through ", 1),
                    _createVNode(_component_PluginPathLink, { plugin: "settings" })
                ])
            ])
        ]),
        _: 1
    }, 8, ["infoPayload", "modelValue", "onOnPopupDone", "onOnPopupCancel", "onOnUserArgChanged"]));
}
